import React, { Fragment } from 'react';
import { useNode, BuilderComponent, getFontStyle, DesignMode } from '@mnz/builder';
import Box from '@mui/material/Box';
import Link from '../../common/components/link/DesignLink';

import LabelIcon from '../../common/components/label-icon/LabelIcon';
import { capitalizeFirstLetter } from '../../shared/utils/string';
import { getBorderCSS, hoverAnimationCss } from '../../common/style';
import OrderLinkSetting, { LinksSettingProps } from './OrderLinkSetting';
import { _order } from '../../shared/utils';

export const OrderLink: BuilderComponent<LinksSettingProps> = ({ designSettings, account, hideOrderItems, order }) => {
    const {
        connectors: { connect, drag },
        query: { getOptions },
        hidden,
    } = useNode((node) => ({
        hidden: node.data.hidden,
    }));

    const canEdit = getOptions().enabled;
    const links = _order(account.orderLinks, order || []);
    if (hidden) return <></>;

    return (
        <Box ref={(ref: HTMLElement) => connect(drag(ref))}>
            {links.map((link) => {
                if (hideOrderItems?.[link.id]) return <></>;
                return (
                    <Link
                        key={link.id}
                        type={link.type.toLowerCase()}
                        url={link.link}
                        isLiveMode={getOptions().mode === DesignMode.LIVE}
                    >
                        <Box
                            sx={{
                                marginTop: '16px',
                                marginX: '35px',
                                ...hoverAnimationCss({ content: '"Order Link"', active: canEdit }),
                            }}
                        >
                            <Box
                                sx={{
                                    ...getBorderCSS({
                                        corner: designSettings.styles.corner,
                                        color: designSettings.colors.button.color,
                                        buttonStyle: designSettings.styles.button,
                                    }),
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'start',
                                    paddingTop: '10px',
                                    paddingBottom: '10px',
                                    paddingLeft: '15px',
                                    paddingRight: !link.type ? '15px' : '45px',
                                    cursor: 'pointer',
                                }}
                            >
                                <LabelIcon
                                    type={designSettings.styles.icon}
                                    icon={capitalizeFirstLetter(link.type)}
                                    size={30}
                                    color={designSettings.colors.buttonText.color}
                                    corner={designSettings.styles.corner}
                                />
                                <Box
                                    sx={{
                                        color: designSettings.colors.buttonText.color,
                                        ...getFontStyle(designSettings, 'secondary', 'bold'),
                                        flexGrow: 1,
                                        textAlign: 'center',
                                    }}
                                >
                                    {link.label ? link.label : 'Order Online'}
                                </Box>
                            </Box>
                        </Box>
                    </Link>
                );
            })}
        </Box>
    );
};

OrderLink.defaultProps = {
    hideOrderItems: {},
    order: [],
};

OrderLink.settings = {
    displayName: 'Ordering Links',
    related: {
        settings: OrderLinkSetting,
    },
    rules: {
        canDrag: () => false,
    },
    custom: {
        showBox: false,
    },
};
